export const SHOW_NORTHEASTERN_INFO = 'SHOW_NORTHEASTERN_INFO'
export const showNortheasternInfo = () => {
  return {
    type: SHOW_NORTHEASTERN_INFO,
  }
}

export const SHOW_THINKFUL_INFO = 'SHOW_THINKFUL_INFO'
export const showThinkfulInfo = () => {
  return {
    type: SHOW_THINKFUL_INFO,
  }
}
export const SHOW_LEWAGON_INFO = 'SHOW_LEWAGON_INFO'
export const showLewagonInfo = () => {
  return {
    type: SHOW_LEWAGON_INFO,
  }
}
